import UseContext from 'hooks/useContext';
import { useCallback, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

export const COMPANY_PARAM = 'idCompany';

/**
 * The company whose panel the address opens (`?idCompany=`): a row of the
 * list, or the form that has just created one, sets the parameter and its
 * panel opens; closing the panel clears it (hooks/useUrlParameters).
 * `selectedId` keeps the last company opened: its row stays lit once the
 * panel is closed, which the parameter alone could not tell.
 */
const useCompanyFromUrl = () => {
  const { setObjID, setSlideOverShow, setSlideOverType } = UseContext();
  const [params, setParams] = useSearchParams();
  const [selectedId, setSelectedId] = useState(null);
  const id = params.get(COMPANY_PARAM);

  useEffect(() => {
    if (!id) return;
    setSelectedId(id);
    setObjID(id);
    setSlideOverType('get_company');
    setSlideOverShow(true);
  }, [id, setObjID, setSlideOverShow, setSlideOverType]);

  // The other parameters of the address stay.
  const openCompany = useCallback(
    (companyId) =>
      setParams((current) => {
        const next = new URLSearchParams(current);
        next.set(COMPANY_PARAM, companyId);
        return next;
      }),
    [setParams],
  );

  return { selectedId, openCompany };
};

export default useCompanyFromUrl;
